<template>
	<svg width="17" height="4" viewBox="0 0 17 4" xmlns="http://www.w3.org/2000/svg">
		<path d="M17 2C17 2.72332 16.4156 3.30769 15.6923 3.30769H1.30769C0.584375 3.30769 0 2.72332 0 2C0 1.27668 0.584375 0.692307 1.30769 0.692307H15.6923C16.4156 0.692307 17 1.27668 17 2Z" fill="#16828F"/>
	</svg>
</template>
